import React from "react"
import ContentLoader from "react-content-loader"

export default function LoadingPlaceholder() {
  return (
    <ContentLoader viewBox="0 0 380 800" rtl={true}>
      <rect x="0" y="10" rx="5" ry="5" width="200" height="20"/>
      <rect x="0" y="40" rx="5" ry="5" width="380" height="60"/>
      <rect x="0" y="110" rx="5" ry="5" width="380" height="60"/>

      <rect x="0" y="220" rx="5" ry="5" width="200" height="20"/>
      <rect x="0" y="250" rx="5" ry="5" width="380" height="100"/>
    </ContentLoader>
  )
}
